export default __webpack_public_path__ + "static/media/phsycologists.7f31e651.jpg";